import { upperCase } from "lodash";
import { ConfidenceType } from "store/types";
import { styled } from "styled-components";
import checkCircle from "./icons/check-circle.svg";
import { Grid } from "@mui/material";

interface IProps {
  score: ConfidenceType;
}

const HighScoreContainer = styled.div`
  padding: 8px 24px;
  background-color: #a0d9d6;
  text-align: center;
`;

const MediumScoreContainer = styled.div`
  padding: 8px 24px;
  background-color: #ffdaa5;
  text-align: center;
`;

const LowScoreContainer = styled.div`
  padding: 8px 24px;
  background-color: #fad3d1;
  text-align: center;
`;

const Description = styled.div`
  font-family: "Roboto";
  font-style: "normal";
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #252525;
`;

const Result = ({ score }: IProps) => {
  return (
    <Grid container spacing={1} alignItems="center" justifyContent="center">
      <Grid item>
        <img src={checkCircle} alt="Check" title="Check" />
      </Grid>
      <Grid item style={{ display: "flex" }}>
        <Description>
          Your site&apos;s alignment score is{" "}
          <strong>{upperCase(score === ConfidenceType.MEDIUM ? "okay" : score)}</strong>
        </Description>
      </Grid>
    </Grid>
  );
};

export const AlignmentScore = ({ score }: IProps) => {
  switch (score) {
    case ConfidenceType.HIGH:
      return (
        <HighScoreContainer>
          <Result score={score} />
        </HighScoreContainer>
      );
    case ConfidenceType.MEDIUM:
      return (
        <MediumScoreContainer>
          <Result score={score} />
        </MediumScoreContainer>
      );
    case ConfidenceType.LOW:
      return (
        <LowScoreContainer>
          <Result score={score} />
        </LowScoreContainer>
      );
    default:
      return null;
  }
};
